export class Feature {
  id: number;
  key: string;
  name: string;
  description?: string;
  status: 'ACTIVE' | 'TRIAL' | 'COMING_SOON';

  deserialize(input: any): Feature {
    Object.assign(this, input);
    return this;
  }
}

export interface AccountFeature {
  id: number;
  accountId: number;
  featureId: number;
  enabled: boolean;
}


